//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex';
import videoplay from '@/components/videoplay.vue';
export default {
  components: {
    videoplay
  },
  name: 'courseintro',
  data() {
    return {
      intro_state: {
        open: false,
        attention: false,
        favourite: false,
        learnstate: false,
        learnfinish: false
      },
      courseDetail: {
        portrait: '/service/rest/tk.File/04ea94f7b4dc4b09aabb9f215436aca1/view',
        name: '人民调解员身心与健康管理人民调解员身心与健康管理',
        score: 4,
        courseTime: 285,
        clickNumber: 114,
        label: ['案例分析', '调解技巧'],
        cover: 'http://pic44.photophoto.cn/20170727/0847085702814554_b.jpg',
        lecturerDescription:
          '上海市徐汇区著名金牌调解员。有着25年丰富的调解经历，粉丝千千万。1987年开始上海市徐汇区著名金牌调解员。有着25年丰富的调解经历，粉丝千千万。1987年开始...市徐汇区著名金牌调解员',
        description:
          '<p>人民调解是人民群众运用自己的力量自我教育、自我管理、自我服务的一种自治活动。它是在人民调解委员会的主持下，以国家法律、法规、规章、政策和社会公德规范为依据，对双方当事人进行调解、劝说，促使他们互相谅解、平等协商、自愿达成协议、消除</p>',
        lecturerName: '朱慧',
        lecturerTitle: '特邀嘉宾',
        attention: false
      },
      video: {
        pic: './images/court.png',
        src:
          'https://cdn.plyr.io/static/demo/View_From_A_Blue_Moon_Trailer-576p.mp4'
      }
    };
  },
  methods: {
    ...mapActions([]),
    cancelAttention() {
      // studentApi.cancelAttention({ lecturerId: this.courseDetail.lecturer });
      this.courseDetail.attention = !this.courseDetail.attention;
    },
    attention() {
      // studentApi.attention({ lecturerId: this.courseDetail.lecturer });
      this.courseDetail.attention = !this.courseDetail.attention;
    }
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
